import {Action, Module, Mutation} from 'vuex-module-decorators'
import store, {authModule, currentUserModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import {eventBus} from "@/main";
import BaseModule from "@/store/modules/BaseModule";
import ApiException = MdbsCore.ApiException;
import BaseClient = MdbsCore.BaseClient;
import router from "@/router";

export enum AlertType {
    info,
    warning,
    error
}

export class Alert {
    public type: AlertType
    public message: string;

    constructor(type: AlertType, message: string) {
        this.type = type;
        this.message = message;
    }
}

@Module({namespaced: true, name: 'alert', store: store})
export default class AlertModule extends BaseModule {
    alerts: Array<Alert> = [];

    @Mutation
    add(alert: Alert) {
        this.alerts.push(alert)
    }

    @Mutation
    remove(alert: Alert) {
        this.alerts.splice(this.alerts.indexOf(alert), 1);
    }

    @Mutation
    removeAll() {
        this.alerts.updateValues([]);
    }

    @Action({commit: 'add', rawError: true})
    async info(message: string) {
        return new Alert(AlertType.info, message)
    }

    @Action({commit: 'add', rawError: true})
    async warning(message: string) {
        return new Alert(AlertType.warning, message)
    }

    @Action({commit: 'add', rawError: true})
    async error(message: string) {
        return new Alert(AlertType.error, message)
    }

    @Action({commit: 'remove', rawError: true})
    async dismiss(alert: Alert) {
        return alert
    }

    @Action({commit: 'removeAll', rawError: true})
    async dismissAll() {
    }

    @Action({rawError: true})
    async handleException(exception: Error) {
        if (exception == null)
            return;

        if (router.currentRoute.name == "login") return;

        console.error(JSON.stringify(exception))
        if (ApiException.isApiException(exception)) {

            const apiException = (<ApiException>exception)
            if (exception.status === 401) {
                if (exception.message === BaseClient.REFRESH_TOKEN_EXPIRED_MESSAGE) {
                    await this.error("Ihr Login ist abgelaufen. Bitte melden Sie sich erneut an.");
                    await authModule.logout();
                    currentUserModule.reset();
                    eventBus.$emit('force-logout');
                    return;
                }
            }

            // @ts-ignore
            this.add(new Alert(AlertType.error, apiException?.response?.title ?? exception.message))
        } else {
            if (exception.message === "Network Error"){
                this.add(new Alert(AlertType.error, "Verbindungsstörung: Überprüfen Sie bitte ihre Internetverbindung."));
                return;
            }
            this.add(new Alert(AlertType.error, JSON.stringify(exception)))
        }
    }
}
